import { render, staticRenderFns } from "./tinymceEditor.vue?vue&type=template&id=3bb490f4&scoped=true"
import script from "./tinymceEditor.vue?vue&type=script&lang=js"
export * from "./tinymceEditor.vue?vue&type=script&lang=js"
import style0 from "./tinymceEditor.vue?vue&type=style&index=0&id=3bb490f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb490f4",
  null
  
)

export default component.exports